<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{
          $t('administration.mobile_feature.notification.monitoring.monitoring')
        }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'administration.mobile_feature.notification.monitoring.monitoring'
            ),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 d-flex justify-content-end">
            <select
              class="form-control mr-2 text-center"
              style="width:300px"
              @change="filter"
              v-model="not_type_id"
            >
              <option value="" selected>{{
                $t(
                  'administration.mobile_feature.notification.monitoring.select_notification_type'
                )
              }}</option>
              <option
                v-for="(notification_type, index) in notification_types"
                :key="index"
                :value="notification_type.not_type_id"
              >
                {{ notification_type.not_type }}
              </option>
            </select>
            <ts-input
              v-model="search"
              :placeholder="
                $t(
                  'administration.mobile_feature.notification.monitoring.search'
                )
              "
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.queue_time }}</td>
          <td>{{ record.notification_type }}</td>
          <td>{{ record.activated_type }}</td>
          <td class="text-center">{{ record.notification_method }}</td>
          <td class="text-center">
            <span
              v-if="record.sending_status"
              v-tooltip="
                $t('administration.mobile_feature.notification.monitoring.sent')
              "
              ><i class="far fa-check-square text-primary"></i
            ></span>
            <span
              v-else
              v-tooltip="
                $t(
                  'administration.mobile_feature.notification.monitoring.padding'
                )
              "
              ><i class="fas fa-redo text-danger"></i
            ></span>
          </td>
          <td class="text-center">{{ record.sent_counter }}</td>
          <td class="text-center">{{ record.sent_time }}</td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'notification-monitoring',
  data() {
    return {
      not_type_id: '',
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('notificationMonitoring', [
      'resources',
      'pagination',
      'notification_types'
    ]),
    search: {
      get() {
        return this.$store.state.notificationMonitoring.search
      },
      set(newValue) {
        this.$store.commit('notificationMonitoring/SET_SEARCH', newValue)
        this.$store.commit('notificationMonitoring/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t(
            'administration.mobile_feature.notification.monitoring.queue_time'
          )
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.monitoring.notification_type'
          )
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.monitoring.activate_type'
          )
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.monitoring.notification_method'
          ),
          style: 'text-align:center'
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.monitoring.status'
          ),
          style: 'text-align:center'
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.monitoring.counter'
          ),
          style: 'text-align:center'
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.monitoring.time'
          ),
          style: 'text-align:center'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('notificationMonitoring/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    filter() {
      this.$store.commit(
        'notificationMonitoring/SET_SELECTED_NOTIFICATION_TYPE',
        this.not_type_id
      )
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('notificationMonitoring/RESET_STATE')
      this.$store.commit(
        'notificationMonitoring/SET_SELECTED_NOTIFICATION_TYPE',
        ''
      )
    }
    next()
  }
}
</script>
